import { render } from "./AssignedTaskToResourceTable.vue?vue&type=template&id=4b7251b4&scoped=true&ts=true"
import script from "./AssignedTaskToResourceTable.vue?vue&type=script&lang=ts"
export * from "./AssignedTaskToResourceTable.vue?vue&type=script&lang=ts"

import "./AssignedTaskToResourceTable.vue?vue&type=style&index=0&id=4b7251b4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7251b4"]])

export default __exports__